import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminStudentAffiliationsApi = createApi({
  reducerPath: "adminStudentAffiliationsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/studentAffiliations/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminStudentAffiliations"],
  endpoints: (builder) => ({
    getStudentAffiliations: builder.query({
      query: ({
        page,
        limit,
        gradYear,
        name,
        email,
        school,
        city,
        affiliation,
        actual,
        selected_by_type_id,
      }) =>
        `all?page=${page}&limit=${limit}&gradYear=${gradYear}
        ${name ? `&name=${encodeURIComponent(name)}` : ""}
        ${email ? `&email=${encodeURIComponent(email)}` : ""}
        ${school ? `&school=${encodeURIComponent(school)}` : ""}
        ${city ? `&city=${encodeURIComponent(city)}` : ""}
        ${affiliation ? `&affiliation=${encodeURIComponent(affiliation)}` : ""}
        ${
          selected_by_type_id
            ? `&selected_by_type_id=${encodeURIComponent(selected_by_type_id)}`
            : ""
        }
        ${actual ? `&actual=${encodeURIComponent(actual)}` : ""}`,
      providesTags: (
        result,
        error,
        {
          page,
          limit,
          gradYear,
          name,
          email,
          school,
          affiliation,
          actual,
          selected_by_type_id,
        }
      ) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "AdminStudentAffiliations",
                id,
              })),
              { type: "AdminStudentAffiliations", id: "PARTIAL-LIST" },
            ]
          : [{ type: "AdminStudentAffiliations", id: "PARTIAL-LIST" }],
    }),
    updateStudentActual: builder.mutation({
      query: ({ id, actual, rejected }) => ({
        url: `update/${id}`,
        method: "PUT",
        body: {
          ...(actual !== undefined && { actual }),
          ...(rejected !== undefined && { rejected }),
        },
      }),
      invalidatesTags: [
        { type: "AdminStudentAffiliations", id: "PARTIAL-LIST" },
      ],
    }),
  }),
});

export const {
  useGetStudentAffiliationsQuery,
  useUpdateStudentActualMutation,
} = adminStudentAffiliationsApi;

export default adminStudentAffiliationsApi;
export { adminStudentAffiliationsApi };
